// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview {
  max-width: 200px;
}
/*CSS classes*/
.text-tabs-1{float:left;}

.text-tabs-2{
  float:right;
  text-align: right;
  width: 88%;
  /*margin-left:120px;*/
  display:block;
  position:absolute;
}

.clearer{clear:both;}

.text-tabs-decription-2{
  float:left;
  margin-left:35px;
  height: 100px;
  max-width: 470px;
}

.p-description {
  text-overflow: ellipsis; /* will make [...] at the end */
  width: 370px; /* change to your preferences */
  white-space: nowrap; /* paragraph to one line */
  overflow:hidden; /* older browsers */
}

::ng-deep lightbox gallery {
  background-color: white !important;
  min-width: 800px;
}

.lightbox {
  /* Default to hidden */
  display: none;

  /* Overlay entire screen */
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /* A bit of padding around image */
  padding: 1em;

  /* Translucent background */
  background: rgba(0, 0, 0, 0.8);
}

/* Unhide the lightbox when it's the target */
.lightbox:target {
  display: block;
}

.lightbox span {
  /* Full width and height */
  display: block;
  width: 100%;
  height: 100%;

  /* Size and position background image */
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

/*
.mat-success {
  background-color: #007bff;
  color: #fff;
}
*/
.example-button-row button,
.example-button-row a {
  margin-right: 8px;
}

.mat-button.mat-success,
.mat-stroked-button.mat-success {
  color: #007bff;
}
.mat-button.mat-success:hover,
.mat-stroked-button.mat-success:hover {
  background-color: #f0fff3;
}

.mat-raised-button.mat-success,
.mat-flat-button.mat-success,
.mat-fab.mat-success,
.mat-mini-fab.mat-success {
  color: #f0fff3;
  background-color: #007bff;
}

.mat-icon-button.mat-success {
  color:#007bff;
}

.header-grid {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two columns */
  gap: 16px; /* Space between items */
  padding: 16px; /* Optional padding for overall grid */
}

.header-item {
  background-color: #f9f9f9; /* Light background for better contrast */
  padding: 8px;
  /*border-bottom: 1px solid #ddd;*/
  /*border-radius: 4px;*/
  /*font-size: 14px;*/
}

.specs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two columns */
  gap: 16px; /* Space between items */
  padding: 16px; /* Optional padding for overall grid */
}

.specs-item {
  background-color: #f9f9f9; /* Light background for better contrast */
  padding: 8px;
  border-bottom: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}



.image-list {
  list-style: none;
  padding-left: 0;
}
.image-list li {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 10px 0;
  color: #6c757d;
}
.image-list img {
  width: 30px;
  margin-right: 10px;
}

.image-list-prof {
  list-style: none;
  padding-left: 0;
}
.image-list-prof li {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 10px 0;
  color: #6c757d;
}
.image-list-prof img {
  width: 20px;
  margin-right: 10px;
}

.image-list-header {
  list-style: none;
  padding-left: 0;

}

.image-list-header img {
  width: 30px;
  margin-left: 0px;
  margin-right: 10px;
}


.custom-tab {
  color: #6c757d !important; /* Default color for inactive tabs */
  font-weight: 500;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out;
}

.custom-tab.active {
  color: #0d6efd !important; /* Selected tab color */
  border-bottom: 2px solid #0d6efd !important; /* Underline effect */
}


`, "",{"version":3,"sources":["webpack://./src/app/category/listing-detail/listing-detail.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA,cAAc;AACd,aAAa,UAAU,CAAC;;AAExB;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA,SAAS,UAAU,CAAC;;AAEpB;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;EACxD,YAAY,EAAE,+BAA+B;EAC7C,mBAAmB,EAAE,0BAA0B;EAC/C,eAAe,EAAE,mBAAmB;AACtC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;;EAEb,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;;EAET,kCAAkC;EAClC,YAAY;;EAEZ,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,6CAA6C;AAC7C;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,WAAW;EACX,YAAY;;EAEZ,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;;;;;CAKC;AACD;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,gBAAgB;EAChD,SAAS,EAAE,wBAAwB;EACnC,aAAa,EAAE,sCAAsC;AACvD;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;EACpE,YAAY;EACZ,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,gBAAgB;EAChD,SAAS,EAAE,wBAAwB;EACnC,aAAa,EAAE,sCAAsC;AACvD;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;EACpE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;;;AAIA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,gBAAgB;EAChB,iEAAiE;AACnE;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,2CAA2C,EAAE,qBAAqB;AACpE","sourcesContent":[".preview {\n  max-width: 200px;\n}\n/*CSS classes*/\n.text-tabs-1{float:left;}\n\n.text-tabs-2{\n  float:right;\n  text-align: right;\n  width: 88%;\n  /*margin-left:120px;*/\n  display:block;\n  position:absolute;\n}\n\n.clearer{clear:both;}\n\n.text-tabs-decription-2{\n  float:left;\n  margin-left:35px;\n  height: 100px;\n  max-width: 470px;\n}\n\n.p-description {\n  text-overflow: ellipsis; /* will make [...] at the end */\n  width: 370px; /* change to your preferences */\n  white-space: nowrap; /* paragraph to one line */\n  overflow:hidden; /* older browsers */\n}\n\n::ng-deep lightbox gallery {\n  background-color: white !important;\n  min-width: 800px;\n}\n\n.lightbox {\n  /* Default to hidden */\n  display: none;\n\n  /* Overlay entire screen */\n  position: fixed;\n  z-index: 999;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  /* A bit of padding around image */\n  padding: 1em;\n\n  /* Translucent background */\n  background: rgba(0, 0, 0, 0.8);\n}\n\n/* Unhide the lightbox when it's the target */\n.lightbox:target {\n  display: block;\n}\n\n.lightbox span {\n  /* Full width and height */\n  display: block;\n  width: 100%;\n  height: 100%;\n\n  /* Size and position background image */\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n/*\n.mat-success {\n  background-color: #007bff;\n  color: #fff;\n}\n*/\n.example-button-row button,\n.example-button-row a {\n  margin-right: 8px;\n}\n\n.mat-button.mat-success,\n.mat-stroked-button.mat-success {\n  color: #007bff;\n}\n.mat-button.mat-success:hover,\n.mat-stroked-button.mat-success:hover {\n  background-color: #f0fff3;\n}\n\n.mat-raised-button.mat-success,\n.mat-flat-button.mat-success,\n.mat-fab.mat-success,\n.mat-mini-fab.mat-success {\n  color: #f0fff3;\n  background-color: #007bff;\n}\n\n.mat-icon-button.mat-success {\n  color:#007bff;\n}\n\n.header-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Two columns */\n  gap: 16px; /* Space between items */\n  padding: 16px; /* Optional padding for overall grid */\n}\n\n.header-item {\n  background-color: #f9f9f9; /* Light background for better contrast */\n  padding: 8px;\n  /*border-bottom: 1px solid #ddd;*/\n  /*border-radius: 4px;*/\n  /*font-size: 14px;*/\n}\n\n.specs-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Two columns */\n  gap: 16px; /* Space between items */\n  padding: 16px; /* Optional padding for overall grid */\n}\n\n.specs-item {\n  background-color: #f9f9f9; /* Light background for better contrast */\n  padding: 8px;\n  border-bottom: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n\n\n.image-list {\n  list-style: none;\n  padding-left: 0;\n}\n.image-list li {\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  margin: 10px 0;\n  color: #6c757d;\n}\n.image-list img {\n  width: 30px;\n  margin-right: 10px;\n}\n\n.image-list-prof {\n  list-style: none;\n  padding-left: 0;\n}\n.image-list-prof li {\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  margin: 10px 0;\n  color: #6c757d;\n}\n.image-list-prof img {\n  width: 20px;\n  margin-right: 10px;\n}\n\n.image-list-header {\n  list-style: none;\n  padding-left: 0;\n\n}\n\n.image-list-header img {\n  width: 30px;\n  margin-left: 0px;\n  margin-right: 10px;\n}\n\n\n.custom-tab {\n  color: #6c757d !important; /* Default color for inactive tabs */\n  font-weight: 500;\n  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out;\n}\n\n.custom-tab.active {\n  color: #0d6efd !important; /* Selected tab color */\n  border-bottom: 2px solid #0d6efd !important; /* Underline effect */\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
